import React, { ReactElement, useState, useEffect } from "react";

import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Lightbox from "react-awesome-lightbox";
import { ZoomIn } from "react-bootstrap-icons";
import "react-awesome-lightbox/build/style.css";
import Footer from "./Footer";
import MoonFeatures from "../assets/moon-features.png";
import { SettingsContext } from "../hooks/settings-context";

export default function Lunar(): ReactElement {
  const [show, setShow] = useState(false);
  useEffect(() => { }, [show]);
  return (
    <SettingsContext.Consumer>
      {({ data }) => (
        <div className="lunar-container" style={{ color: "white" }}>
          <Container fluid>
            <Row className="custom__row full-height">
              <Col md={6} className="full-height">
                <div className="lunar-left-col full-height">
                  <Card className="pb-2 pt-2 px-2 full-height lunar-phase-card">
                    <h6 className="lunar-panel-header">Lunar Phase and Libration</h6>
                    <div style={{ display: `${show === true ? "" : "none"}` }}>
                      <Lightbox
                        image="https://assets.obsmoana.com/venus/assets/lunar-phase-latest.png"
                        title="Libration"
                        onClose={() => {
                          setShow(false);
                        }}
                      />
                    </div>
                    <div className="lunar-phase-content">
                      <Image
                        src="https://assets.obsmoana.com/venus/assets/lunar-phase-thumbnail.png"
                        className="lunar-phase-image"
                        onClick={() => {
                          setShow(true);
                        }}
                      />
                      <span className="lunar-phase-zoom">
                        <ZoomIn
                          onClick={() => {
                            setShow(true);
                          }}
                        />
                      </span>
                    </div>
                  </Card>
                  <Card className="pb-2 pt-2 px-2 full-height lunar-landing-card">
                    <h6 className="lunar-panel-header">Lunar Landing Sites</h6>
                    <div className="lunar-card-content">
                      <iframe
                        title="Lunar Landing Sites"
                        src="https://www.arcgis.com/apps/Styler/index.html?appid=eb8382bfcf0b4d7885f3e39dc0e49e2e"
                        className="full-height"
                      />
                    </div>
                  </Card>
                </div>
              </Col>
              <Col md={6} className="full-height">
                <Card className="pt-2 full-height lunar-map-card">
                  <Card.Body className="p-0 d-flex flex-column flex-grow-1">
                    <Card.Title className="h6 lunar-panel-header px-2 mb-0">Lunar Map</Card.Title>
                    <div className="lunar-map-image-wrap">
                      <Image
                        src={MoonFeatures}
                        className="lunar-map-image"
                      />
                    </div>
                    <small className="lunar-map-caption">Image from the planet Society</small>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
          <Footer />
        </div>
      )}
    </SettingsContext.Consumer>
  );
}
